<template>
  <div :class="['bf-alert', `bf-alert--${variant}`]" role="alert">
    <i :class="['bf-alert__icon', icon]"></i>
    <span class="bf-alert__msg">{{ message }}</span>
    <button
      type="button"
      class="bf-alert__close"
      aria-label="Fechar"
      @click="closeAlert"
    >
      <i class="ri-close-line"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue";

export default defineComponent({
  name: "AlertComponent",
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String as () => "success" | "error" | "warning" | "info",
      default: "success",
      required: true,
    },
  },
  setup(props, { emit }) {
    const variant = computed(() => {
      switch (props.type) {
        case "error":
          return "err";
        case "warning":
          return "warn";
        case "info":
          return "info";
        default:
          return "ok";
      }
    });

    const icon = computed(() => {
      switch (props.type) {
        case "error":
          return "ri-error-warning-line";
        case "warning":
          return "ri-alert-line";
        case "info":
          return "ri-information-line";
        default:
          return "ri-checkbox-circle-line";
      }
    });

    const closeAlert = () => {
      emit("close-alert", true);
    };

    onMounted(() => {
      setTimeout(() => {
        closeAlert();
      }, 3500);
    });

    return {
      variant,
      icon,
      closeAlert,
    };
  },
});
</script>

<style lang="scss" scoped>
.bf-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;

  &__icon {
    font-size: 18px;
    flex: none;
  }

  &__msg {
    flex: 1;
    min-width: 0;
  }

  &__close {
    flex: none;
    border: none;
    background: transparent;
    cursor: pointer;
    color: inherit;
    opacity: 0.7;
    font-size: 16px;
    line-height: 1;
    padding: 2px;
    display: inline-flex;

    &:hover {
      opacity: 1;
    }
  }

  &--ok {
    background: var(--ok-bg);
    color: var(--ok-fg);
  }
  &--err {
    background: var(--err-bg);
    color: var(--err-fg);
  }
  &--warn {
    background: var(--warn-bg);
    color: var(--warn-fg);
  }
  &--info {
    background: var(--info-bg);
    color: var(--info-fg);
  }
}
</style>
